import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import CustomCard from "../CustomCard";

import Mug from "../../../assets/images/DeskDecoratives/PhotoMug.webp";
import MousePad from "../../../assets/images/DeskDecoratives/MousePad.jpg";
import WoodenFrame from "../../../assets/images/DeskDecoratives/WoodenFrame.jpg";

// Card Data
const cardData = [
  { image: Mug, text: "Personalized Mugs" },
  { image: MousePad, text: "Custom Mouse Pads" },
  { image: WoodenFrame, text: "Content for card 3" },
];

function HomeSection3() {
  return (
    <>
      <Container className="mt-4 w-100 p-0">
        <h2 className="py-4 fw-bold text-center">Desk Decoractives</h2>

        {/* 1st row */}

        <Row>
          <Col md={6} className="d-flex">
            <CustomCard image={cardData[0].image} text={cardData[0].text} />
          </Col>
          <Col md={3} className="d-flex">
            <CustomCard image={cardData[1].image} text={cardData[1].text} />
          </Col>
          <Col md={3} className="d-flex">
            <CustomCard image={cardData[2].image} text={cardData[2].text} />
          </Col>
        </Row>

        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default HomeSection3;
